













































import { defineComponent, ref } from "@vue/composition-api";
import { useGetters } from "vuex-composition-helpers";
import useFetcher from "@use/useFetcher";
import NoteCard from "@c/molecules/note/NoteCard.vue";
import CreateButton from "@c/atoms/app/CreateButton.vue";
import SkeletonIndex from "@c/molecules/note/SkeletonIndex.vue";
import PlaceModel from "@/ts/models/placeClass";

export default defineComponent({
  name: "Notes",

  components: {
    NoteCard,
    CreateButton,
    SkeletonIndex
  },

  props: {
    place: Object as () => PlaceModel
  },

  setup(props, { root }) {

    var hash = ref(null);
    const place_id = parseInt(root.$route.params.id);

    var { entity: notes, loading: loading_notes } = useFetcher(
      "note/GET_NOTES_BY_PLACE",
      {action_param:place_id}
    );

    return {
      notes,
      loading_notes
    };
  }
});
